<template>
  <div class="progress">
    <div class="progress-bar" :style="{ width: progressWidth }"></div>
  </div>
</template>

<script>
export default {
  name: 'adx-progress-bar',
  props: {
    width: {
      required: false,
      default: 0
    }
  },
  data() {
    return {
      dataWidth: this.width
    }
  },
  computed: {
    progressWidth: function() {
      return `${this.dataWidth}%`
    }
  },
  watch: {
    width(newValue, oldValue) {
      this.dataWidth = newValue
    }
  }
}
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>
